import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgageCalculators from "@/pages/MortgageCalculators";

export const Route = createFileRoute("/mortgage-calculators")({
  head: () => seoHead("/mortgage-calculators"),
  component: MortgageCalculators,
});
